export function isPrerendering() {
  return window.navigator.userAgent === "ReactSnap";
}
